import {Type} from 'main.core';
import {Node} from 'landing.node';

export class Ul extends Node
{
	constructor()
	{
		super();
	}

	setName()
	{

	}
}